import "./CloseDealModal.css";

import { ActionButtons, Column, ErrorBox, InformationBox, Modal, Row, Select } from "../../../../../widget";
import { CLOSE_DEAL_REASON_OPTIONS, CLOSE_DEAL_STATUS_OPTIONS } from "./constants";
import { CloseDealModalProps, CloseDealStatus } from "./models";
import { useCloseDealModal } from "./useCloseDealModal";

export const CloseDealModal = ({
  show,
  closeModal,
  deal,
  dealUuid,
  workflowUuid,
  refreshDeal,
  applyCloseDealUpdate,
}: CloseDealModalProps): JSX.Element => {
  const {
    status,
    dealLostReason,
    isRejected,
    isSubmitDisabled,
    isHandleSubmitLoading,
    hasOutstandingTasks,
    errors,
    setStatus,
    setDealLostReason,
    handleCloseModal,
    handleSubmit,
  } = useCloseDealModal({
    show,
    closeModal,
    dealUuid,
    workflowUuid,
    rowVersion: deal.rowVersion,
    refreshDeal,
    applyCloseDealUpdate,
  });

  return (
    <Modal show={show} title="Close deal" onClose={handleCloseModal}>
      <form onSubmit={handleSubmit}>
        {errors && errors.length > 0 && (
          <Row spacingV="ml" justify="center">
            <Column span={6}>
              <ErrorBox
                title="Please solve the below issues before saving"
                text={errors.map((error) => error.message)}
              />
            </Column>
          </Row>
        )}
        <Row spacingV="ml" justify="center">
          <Column span={6}>
            <Select
              className="CloseDealModalSelect"
              label="Decision"
              placeholder="Select decision"
              data={CLOSE_DEAL_STATUS_OPTIONS}
              value={status}
              onChange={(value) => {
                const nextStatus = value as CloseDealStatus;
                setStatus(nextStatus);
                if (nextStatus !== "Rejected") {
                  setDealLostReason("");
                }
              }}
            />
          </Column>
        </Row>
        {isRejected && (
          <Row spacingV="ml" justify="center">
            <Column span={6}>
              <Select
                className="CloseDealModalSelect"
                label="Loss reason"
                placeholder="Select loss reason"
                data={CLOSE_DEAL_REASON_OPTIONS}
                value={dealLostReason}
                onChange={setDealLostReason}
              />
            </Column>
          </Row>
        )}
        {hasOutstandingTasks && (
          <Row spacingV="ml" justify="center">
            <Column span={6}>
              <InformationBox variant="alert" corners="rounded">
                There are outstanding tasks to complete on this deal. Do you wish to proceed?
              </InformationBox>
            </Column>
          </Row>
        )}
        <Row spacingV="ll" justify="center">
          <Column span={6}>
            <ActionButtons
              onCancel={handleCloseModal}
              submitButtonLabel="Close deal"
              isLoading={isHandleSubmitLoading}
              disabled={isSubmitDisabled}
              fullWidth
            />
          </Column>
        </Row>
      </form>
    </Modal>
  );
};
